import Button from 'components/Button';
import Div from 'components/Div';
import React from 'react';
import styled from 'styled-components';
import { AiOutlineMinus, AiOutlinePlus } from 'react-icons/ai'
import { formatNumber } from 'utils/vanillaFunctions';

const PizzaPopup = ({ name, data, onChange, disableIncrement }) => {
    const [size, setSize] = React.useState(null)
    const [base, setBase] = React.useState(null)
    const [count, setCount] = React.useState(1)

    // Auto-select first size on mount
    React.useEffect(() => {
        if (data.sizes?.length > 0) {
            setSize(data.sizes[0])
        }
    }, [data.sizes])

    const getAvailableBases = React.useCallback((selectedSize) => {
        if (!selectedSize || !data.definitions?.length) return data.bases ?? []
        const validBaseIds = new Set(
            data.definitions
                .filter(d => d.sizeId === selectedSize.id)
                .map(d => d.baseId)
        )
        return (data.bases ?? []).filter(b => validBaseIds.has(b.id))
    }, [data.definitions, data.bases])

    // When size changes, auto-select first available base for that size
    React.useEffect(() => {
        if (!size) return
        const availableBases = getAvailableBases(size)
        setBase(availableBases.length > 0 ? availableBases[0] : null)
    }, [size, getAvailableBases])

    const availableBases = React.useMemo(
        () => size ? getAvailableBases(size) : [],
        [size, getAvailableBases]
    )

    // Find the matching definition for the current size+base selection
    const selectedDefinition = React.useMemo(() => {
        if (!size || !base || !data.definitions?.length) return null
        return data.definitions.find(d => d.sizeId === size.id && d.baseId === base.id) ?? null
    }, [size, base, data.definitions])

    const displayPrice = selectedDefinition?.price ?? null

    const handleAdd = (e) => {
        e.preventDefault()
        onChange({ ...selectedDefinition, size, base, count })
    }

    return (
        <Container>
            {data.imageUrl
                ? <img className='pizza_img' src={data.imageUrl} alt='pizza_img' />
                : <img className='pizza_img empty' src='/images/pizza.png' alt='pizza_img_empty' />
            }

            {displayPrice != null && !disableIncrement && (
                <Div c="operation">
                    <Div c="left_wrap">
                        <Div c="count_wrap">
                            <Button onClick={() => count > 1 && setCount(count - 1)}><AiOutlineMinus /></Button>
                            <Div c="count">{count}</Div>
                            <Button onClick={() => setCount(count + 1)}><AiOutlinePlus /></Button>
                        </Div>
                    </Div>
                    <Div c="right_wrap">
                        <Div c="total">{'₮' + formatNumber(displayPrice * count)}</Div>
                    </Div>
                </Div>
            )}

            <Div c="choice_title">Хэмжээ</Div>
            <Div c="choice_wrap">
                {(data.sizes ?? []).map(s => (
                    <Button
                        key={s.id}
                        onClick={() => setSize(s)}
                        open={size?.id === s.id}
                    >
                        {s.name}
                    </Button>
                ))}
            </Div>

            <Div c="choice_title">Гурил</Div>
            <Div c="choice_wrap">
                {availableBases.map(b => (
                    <Button
                        key={b.id}
                        onClick={() => setBase(b)}
                        open={base?.id === b.id}
                    >
                        {b.name}
                    </Button>
                ))}
            </Div>

            {size && base && !selectedDefinition && (
                <p className='errorLine'>{name} - {base.name} {size.name} сонголт гарах боломжгүй байна</p>
            )}

            <Button onClick={handleAdd} disabled={!selectedDefinition} className="add_to_cart">
                Сагсанд хийх
            </Button>
        </Container>
    );
};

export default PizzaPopup;

const Container = styled.div`
    padding:0px;
    max-width:350px;
    min-width:350px;
    margin:auto;
    .pizza_img{
        width:100%;
        margin-bottom:15px;
        display:block;
        &.empty{
            height:150px;
            object-fit:contain;
            opacity:0.3;
            padding:15px;
            border:2px solid rgba(0,0,0,0.1);
        }
    }
    .operation{
        display:flex;
        align-items:center;
        justify-content:space-between;
        font-size:16px;
        margin-bottom:15px;
        .left_wrap{
            .count_wrap{
                border:2px solid rgba(0,0,0,0.1);
                border-radius:4px;
                padding:0px 0px;
                display:flex;
                align-items:center;
                gap:5px;
                button{
                    border:none;
                    color:black;
                }
                .count{
                    font-weight:400;
                    margin-top:3px;
                    user-select:none;
                }
            }
        }
        .right_wrap{
            .total{
                font-weight:300;
                font-size:24px;
                margin-top:2px;
                user-select:none;
            }
        }
    }
    .choice_title{
        margin-top:15px;
        margin-bottom:10px;
        padding-bottom:10px;
        border-bottom:1px solid rgba(0,0,0,0.1);
    }
    .choice_wrap{
        display:flex;
        gap:8px;
        margin-bottom:8px;
        flex-wrap:wrap;
        button{
            max-width:80px;
            flex: calc(100% / 3);
            border:2px solid rgba(0,0,0,0.1);
            border-radius:4px;
            padding:8px 8px;
            text-align:center;
            user-select:none;
            cursor:pointer;
            color:inherit;
            transition:0.3s ease;
            font-size:12px;
            &[open]{
                cursor:default;
                border-color:${({theme})=>theme.color};
                color:${({theme})=>theme.color};
                font-weight:bold;
            }
        }
    }
    .add_to_cart{
        margin-top:20px;
        background:${({ theme }) => theme.color};
        width:100%;
        border-radius:4px;
        font-size:14px;
    }
    .errorLine{
        text-align:center;
        color: ${({theme})=>theme.color};
        margin-top:15px;
    }
`
